import { combineReducers } from '@reduxjs/toolkit';

import { auth } from 'store/auth/authSlice';
import { common } from 'store/common/commonSlice';
import { finder } from 'store/finder/finderSlice';
import { messenger } from 'store/messenger/messengerSlice';
import { notifications } from 'store/notifications';
import { oneClickPayment } from 'store/oneClickPayment/oneClickPaymentSlice';
import { payment } from 'store/payment/paymentSlice';
import { profile } from 'store/profile/profileSlice';
import { systemPopup } from 'store/systemPopup/systemPopupSlice';
import { videoCast } from 'store/videoCast/videoCastSlice';

export const rootReducer = combineReducers({
  auth,
  finder,
  messenger,
  common,
  payment,
  oneClickPayment,
  videoCast,
  systemPopup,
  profile,
  notifications,
});

export type RootState = ReturnType<typeof rootReducer>;
